import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Container,
    TextField,
    Button,
    Card,
    CardContent,
    Typography,
    Grid,
    InputAdornment,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import iTree from "../../assets/New-Itree.jpg";
import config from "../config";

const Login = ({ setIsAuthenticated }) => {
    const [empCode, setEmpCode] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async () => {
        try {
            const url = `${config.API_BASE_URL}/login?Empcode=${encodeURIComponent(empCode)}&Password=${encodeURIComponent(password)}`;
    
            // console.log("Login API URL:", url);
    
            const response = await fetch(url, {
                method: "GET",
                headers: { "Content-Type": "application/json" }
            });
    
            const result = await response.json();
    
            // console.log("Login Response:", result);
    
            if (response.ok && result.UserLoggedIn) {
                localStorage.setItem("userLoggedIn", "true");
                localStorage.setItem("Empcode", result.Empcode);
                localStorage.setItem("Boardroom_AccessLevel", result.Boardroom_AccessLevel);
                localStorage.setItem("EmployeeName", result.EmployeeName);
    
                setIsAuthenticated(true);
                window.location.href = "/dashboard";
            } else {
                console.error("Login Failed:", result.message);
                setError(true);
            }
        } catch (error) {
            console.error("Error during login:", error);
            setError(true);
        }
    };

    return (
        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: "100vh" }}>
            {/* Left Side - Image */}
            <Grid item md={8} xs={12} sx={{ display: "flex", justifyContent: "center" }}>
                <img
                    src={iTree}
                    alt="iTree"
                    style={{
                        width: "100%",
                        objectFit: "contain",
                    }}
                />
            </Grid>

            {/* Right Side - Login Form */}
            <Grid item md={4} xs={12} sx={{ p: 2 }}>
                <Typography variant="h4" fontWeight="bold" align="center" sx={{ mb: 2 }}>
                    Online Reservation System
                </Typography>

                <Card elevation={3} sx={{ p: 3, borderTop: "4px solid blue" }}>
                    <CardContent>
                        <Typography variant="h4" fontWeight="bold" align="center" gutterBottom>
                            Login
                        </Typography>
                        <hr />

                        {/* Employee Code Input */}
                        <TextField
                            fullWidth
                            autoFocus
                            variant="outlined"
                            label="Employee Code"
                            margin="normal"
                            value={empCode}
                            onChange={(e) => {
                                setEmpCode(e.target.value);
                                setError(false);
                            }}
                            error={error}
                            helperText={error ? "Invalid Employee Code or Password" : ""}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <AccountCircleIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        {/* Password Input */}
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Password"
                            type="password"
                            margin="normal"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setError(false);
                            }}
                            error={error}
                            helperText={error ? "Invalid Employee Code or Password" : ""}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <LockIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        {/* Login Button */}
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            sx={{ mt: 2, py: 1.5, fontSize: "16px" }}
                            onClick={handleLogin}
                        >
                            Sign In
                        </Button>
                    </CardContent>

                    <Typography variant="body2" align="center" sx={{ mt: 2, color: "gray" }}>
                        Powered by MIS Department
                    </Typography>
                </Card>
            </Grid>
        </Grid>
    );
};

export default Login;
